import Utility from 'api/classes/Utility';
import { PUT } from 'api/constants';

const getImageCdnUrl = async(file: any) => {
  const config = {
    headers: {
      'x-amz-acl': 'bucket-owner-full-control',
      'Content-Type': file.type,
      withoutAuthorization: true,
      dontConvert: true,
    },
  };

  const { data }: any = await Utility.getCdnImageUrl({
    imageContentType: file.type,
    image_name: 'LogoImage',
    subFolder: 'Suppliers',
  });

  await Utility.customRequest({ url: data.uploadUrl, method: PUT, data: file, config });

  return data.cdnUrl;
};

export default getImageCdnUrl;
